export default "__VITE_ASSET__DV$43bT0__"